import { CategoryRotation } from './../../sdk/models/CategoryRotation';
import { PlayerService } from './../../../player/services/player.service';
import { KeyboardEvent } from 'ngx-bootstrap/utils/facade/browser';
import { ScheduleService } from './../../../player/services/schedule.service';
import { ScheduleData } from '../../../player/services/schedule-data.interface';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { SelectItem } from 'primeng/components/common/selectitem';
import { TreeNode, TreeTable, Calendar } from 'primeng/primeng';
import { RotationItem } from '../../sdk/models/RotationItem';
import { filter } from 'rxjs/operator/filter';
import { NouisliderComponent } from 'ng2-nouislider';
import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash';

interface ScheduleTreeData {
  name: string;
  dwellTime: string;
  size: string;
  type: string;
  thumbnail: string;
  icon: string;
  id: string;
  parentId: string;
  index: number;
  skipReasons: string[];
}

@Component({
  selector: 'app-schedule-view',
  templateUrl: './schedule-view.component.html',
  styleUrls: ['./schedule-view.component.css']
})
export class ScheduleViewComponent implements OnInit, OnDestroy {


  @ViewChild('datepicker') datepicker: Calendar;
  @Input() showRaw = false;
  @Input() scrollHeight = 170;
  public scrollHeightStr = '';
  @Input() currentlyPlaying: RotationItem;
  @Input() nextPlay: RotationItem;
  @Input() preloadedScreen: RotationItem;
  public isSliding = false;
  public totalRuntimeStr = '00:00:00';
  public scheduleDataVal: ScheduleData;
  @Output() scheduleDataChange = new EventEmitter();
  @Input()
  get scheduleData() {
    return this.scheduleDataVal;
  }
  set scheduleData(val) {
    this.scheduleDataVal = val;

    // initial values
    if (val) {
      this.totalRuntimeStr = this.hhmmss(this.scheduleData.totalRuntime);
      // build the correct view
      this.createView(this.selectedViewType, this.asOfDate);
    }


    this.scheduleDataChange.emit(this.scheduleDataVal);
  }

  private asOfDateVal: Date = new Date();
  @Output() asOfDateChange = new EventEmitter();
  @Input()
  get asOfDate() {
    return this.asOfDateVal;
  }
  set asOfDate(val) {

    this.asOfDateVal = val;

    // initial values
    if (val) {

      if (!this.isSliding && this.timeSlider) {
        const d = new Date(this.asOfDate);
        this.timeSliderConfig.start[0] = d.getTime();
        this.timeSliderConfig.range.min = this.timestamp(d.toDateString() + ' 00:00:00');
        this.timeSliderConfig.range.max = this.timestamp(d.toDateString() + ' 23:59:59');
        this.timeSlider.slider.updateOptions(this.timeSliderConfig);

        // build the correct view
        this.createView(this.selectedViewType, this.asOfDate);

      }
    }



  }




  public timeSliderConfig = {
    connect: true,
    start: [this.timestamp(this.asOfDate)],
    range: {
      min: this.timestamp(this.asOfDate.toDateString() + ' 00:00:01'),
      max: this.timestamp(this.asOfDate.toDateString() + ' 23:59:59')
    },
    tooltips: false,
    step: 300000,
    orientation: 'horizontal',
    pips: {
      mode: 'count',
      values: 13,
      density: 4.16,
      format: {
        to: (value) => {
          const d = new Date(value);
          return `${d.getHours()}`;
        },
        from: (value) => {
          // const d = new Date();
          // d.setHours(value.split(':')[0]);
          // d.setMinutes(value.split(':')[1]);
          // return new Date(d.toDateString() + ` ${d.getHours()}:${d.getMinutes()}:00`).getTime();
        }
      }
    }
  };

  @ViewChild('timeSlider') timeSlider: NouisliderComponent;
  @ViewChild('tt') tt: TreeTable;
  public scheduleFilterText = '';
  public hideInactive = false;
  public selectedViewType = 'screens';
  public viewTypes: SelectItem[] = [];
  public sliderChangeSubject = new Subject<number>();
  public ngUnsubscribe = new Subject<any>();
  public loadingView = false;


  // info view vars
  public scheduleSizeStr = '';

  // raw view vars
  public rawView = '';

  // treview vars
  public treeNodeData: TreeNode[] = [];
  public treeExpanded = false;

  // screenview vars
  public screenListRotations: CategoryRotation[] = [];
  public screenListRotationsFiltered: CategoryRotation[] = [];


  constructor(
    public playerService: PlayerService
  ) {

    this.viewTypes = [

      { label: 'General', value: 'info', icon: 'fa fa-fw fa-exclamation-circle' },
      // { label: 'Play Order', value: 'playorder', icon: 'fa fa-fw fa-exchange' },
      { label: 'Screens', value: 'screens', icon: 'fa fa-fw fa-photo' },
      { label: 'Tree View', value: 'treeview', icon: 'fa fa-fw fa-folder-open' }

    ];


  }

  ngOnInit() {
    if (this.showRaw) {
      this.viewTypes.push({ label: 'Raw', value: 'raw', icon: 'fa fa-fw fa-exclamation-circle' });
    }

    // throttle slider change
    this.sliderChangeSubject.takeUntil(this.ngUnsubscribe).debounceTime(300).subscribe(value => {
      this.createView(this.selectedViewType, this.asOfDate);


    });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

  }

  timestamp(str) {
    return new Date(str).getTime();
  }

  onTimeSliderUpdate(event) {
    if (this.isSliding) {
      this.asOfDate = new Date(event);
      this.sliderChangeSubject.next(event);
      this.loadingView = true; // say we are loading now, even though we haven't actually started yet.  The slider has a debounce time
    }
  }

  onSlideStart(event) {
    this.isSliding = true;
  }

  onSlideEnd(event) {
    this.isSliding = false;
  }

  onCalanderSelect(event) {
    this.isSliding = false;
    const d = new Date(this.asOfDate);
    const curtime = parseInt(this.timeSlider.slider.get(), 10);
    const orgDate = new Date(curtime);
    d.setHours(orgDate.getHours());
    d.setMinutes(orgDate.getMinutes());
    d.setSeconds(orgDate.getSeconds());
    this.timeSliderConfig.start[0] = d.getTime();
    this.timeSliderConfig.range.min = this.timestamp(d.toDateString() + ' 00:00:00');
    this.timeSliderConfig.range.max = this.timestamp(d.toDateString() + ' 23:59:59');
    this.timeSlider.slider.updateOptions(this.timeSliderConfig);

    this.createView(this.selectedViewType, this.asOfDate);

    if (this.datepicker) {
      this.datepicker.overlayVisible = false;
    }

  }


  setAsOfDateNow() {
    this.asOfDate = new Date();


    const d = new Date(this.asOfDate);
    this.timeSliderConfig.start[0] = d.getTime();
    this.timeSliderConfig.range.min = this.timestamp(d.toDateString() + ' 00:00:00');
    this.timeSliderConfig.range.max = this.timestamp(d.toDateString() + ' 23:59:59');
    this.timeSlider.slider.updateOptions(this.timeSliderConfig);


    if (this.timeSlider) {
      this.timeSlider.slider.set(this.timestamp(this.asOfDate));
    }
  }

  onScheduleFilterKeyUp(event: KeyboardEvent) {
    this.filterSchedule(this.selectedViewType);
  }

  filterSchedule(filterType: string) {
    switch (filterType) {
      case 'info':

        break;
      case 'playorder':

        break;
      case 'screens':
        this.screenListRotationsFiltered = [];

        for (const rotation of this.screenListRotations) {

          // make rotationitem nodes
          for (const lp of rotation.screenLayout.layoutPanels) {

            lp.rotationItems = lp.rotationItems.filter(ri => {

              if (!this.scheduleFilterText) {
                // add rotation to filtered list if it doesn't already exist
                if (!this.screenListRotationsFiltered.find(item => { return item.id === rotation.id; })) {
                  this.screenListRotationsFiltered.push(rotation);
                }
                return true;
              }
              if (ri.screen && ri.screen.ScreenName && ri.screen.ScreenName.toLowerCase().indexOf(this.scheduleFilterText.toLowerCase()) > -1) {
                // add rotation to filtered list if it doesn't already exist
                if (!this.screenListRotationsFiltered.find(item => { return item.id === rotation.id; })) {
                  this.screenListRotationsFiltered.push(rotation);
                }
                return true;
              }
              if (ri.screenCategory && ri.screenCategory.childRotationItems) {
                for (const cri of ri.screenCategory.childRotationItems) {

                  if (cri.screen && cri.screen.ScreenName && cri.screen.ScreenName.toLowerCase().indexOf(this.scheduleFilterText.toLowerCase()) > -1) {
                    // add rotation to filtered list if it doesn't already exist
                    if (!this.screenListRotationsFiltered.find(item => { return item.id === rotation.id; })) {
                      this.screenListRotationsFiltered.push(rotation);
                    }
                    return true;
                  }
                }
              }

              return false;
            });


          }

        }


        break;
      case 'treeview':

        break;
      case 'raw':

        break;

      default:
        // schedule
        break;
    }
  }

  onViewTypeChange(event) {
    this.createView(event.option.value, this.asOfDate);

  }

  createView(type: string, compareDate: Date) {
    this.loadingView = true;

    switch (type) {
      case `info`:
        this.createInfoView(compareDate);
        this.scrollHeightStr = `calc(100% - ${this.scrollHeight - 120}px)`;
        break;
      case `playorder`:
        this.createPlayOrderView(compareDate);
        this.scrollHeightStr = `calc(100% - ${this.scrollHeight}px)`;
        break;
      case `screens`:
        this.createScreensView(compareDate);
        this.scrollHeightStr = `calc(100% - ${this.scrollHeight}px)`;
        break;
      case `treeview`:
        this.createTreeView(compareDate);
        this.scrollHeightStr = `calc(100% - ${this.scrollHeight}px)`;
        break;
      case `raw`:
        this.createRawView();
        this.scrollHeightStr = `calc(100% - ${this.scrollHeight - 120}px)`;
        break;

      default:
        // schedule
        break;
    }

    this.filterSchedule(type);
    this.loadingView = false;
  }

  createInfoView(compareDate?) {
    this.scheduleSizeStr = this.formatBytes(this.scheduleData.scheduleSize);
  }

  formatBytes(bytes, decimals = 0) {
    if (bytes === 0) { return '0 Bytes'; }
    const k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  createRawView() {
    if (this.scheduleData) {
      this.rawView = JSON.stringify(this.scheduleData, null, 2);
    } else {
      this.rawView = '';
    }

  }

  toggleAllTree() {
    this.treeExpanded = !this.treeExpanded;

    for (const item of this.treeNodeData) {
      this.expandNode(item, this.treeExpanded);
    }

    this.treeNodeData = this.treeNodeData.slice();
  }

  expandNode(node: TreeNode, value: boolean) {
    node.expanded = value;

    if (node.children && node.children.length) {
      for (const item of node.children) {
        this.expandNode(item, value);
      }
    }
  }

  createTreeView(compareDate?: Date) {

    if (!compareDate) {
      compareDate = new Date();
    }

    this.treeNodeData = []; // clear array

    for (const rotation of this.scheduleData.categoryRotations) {

      // make string of names for playergroups
      let pgNames = '';
      pgNames = rotation.playerGroups.map(item => { return item.name; }).toString();

      const pgtd: ScheduleTreeData = {
        name: pgNames,
        type: 'Player Groups',
        size: '',
        dwellTime: '',
        thumbnail: '',
        icon: 'fa fa-th-list fa-fw',
        index: -1,
        id: rotation.id,
        parentId: '',
        skipReasons: []
      };

      const pgNode: TreeNode = {
        data: pgtd,
        children: [],
        expanded: this.treeExpanded
      };


      const td: ScheduleTreeData = {
        name: rotation.name,
        type: 'Rotation Playlist',
        size: '',
        dwellTime: '',
        thumbnail: '',
        icon: 'fa fa-retweet fa-fw',
        index: -1,
        id: rotation.id,
        parentId: '',
        skipReasons: []
      };

      const rotNode: TreeNode = {
        data: td,
        children: [],
        expanded: this.treeExpanded
      };

      pgNode.children.push(rotNode);

      // make rotationitem nodes
      for (const lp of rotation.screenLayout.layoutPanels) {

        let riIndex = -1;
        for (const ri of lp.rotationItems) {

          riIndex += 1;

          (<any>ri).parentCategoryRotationId = rotation.id;

          // add screen
          if (ri.screen) {

            const screenData: ScheduleTreeData = {
              name: ri.screen.ScreenName,
              type: 'Screen Design',
              size: this.formatBytes(ri.screen.ScreenSizeInBytes),
              dwellTime: ri.screen.MinimumScheduleTime.toString(),
              thumbnail: ri.screen.urlThumb3,
              icon: 'fa fa-tv fa-fw',
              id: ri.id,
              parentId: rotation.id,
              index: riIndex,
              skipReasons: this.getSkipReasons(ri, null, rotation, compareDate)
            };

            const screenNode: TreeNode = {
              data: screenData,
              children: [],
              expanded: this.treeExpanded
            };

            rotNode.children.push(screenNode);
          }

          // add category
          if (ri.screenCategory) {

            const catData: ScheduleTreeData = {
              name: ri.screenCategory.name,
              type: 'Screen Category',
              size: '',
              dwellTime: '',
              thumbnail: '',
              icon: 'fa fa-cubes fa-fw',
              id: ri.id,
              index: riIndex,
              parentId: rotation.id,
              skipReasons: []
            };

            const catNode: TreeNode = {
              data: catData,
              children: [],
              expanded: this.treeExpanded
            };



            let criIndex = -1;
            // add ri's of category
            for (const cri of ri.screenCategory.childRotationItems) {
              criIndex += 1;
              const screenData: ScheduleTreeData = {
                name: cri.screen.ScreenName,
                type: 'Screen Design',
                size: this.formatBytes(cri.screen.ScreenSizeInBytes),
                dwellTime: cri.screen.MinimumScheduleTime.toString(),
                thumbnail: cri.screen.urlThumb3,
                icon: 'fa fa-tv',
                id: cri.id,
                parentId: ri.id,
                index: criIndex,
                skipReasons: this.getSkipReasons(cri, null, rotation, compareDate)
              };

              (<any>cri).parentRotationItemId = ri.id;
              (<any>cri).parentCategoryRotationId = rotation.id;

              const screenNode: TreeNode = {
                data: screenData,
                children: [],
                expanded: this.treeExpanded
              };
              catNode.children.push(screenNode);
            }

            // add category
            rotNode.children.push(catNode);
          }

        }

      }
      this.treeNodeData.push(pgNode);

    }



    return this.treeNodeData;
  }

  createScreensView(compareDate?: Date) {
    if (!compareDate) {
      compareDate = new Date();
    }
    this.screenListRotations = _.cloneDeep(this.scheduleData.categoryRotations);


    for (const rotation of this.screenListRotations) {

      // make playergroup string
      (<any>rotation).playerGroupStr = '';
      for (const pg of rotation.playerGroups) {
        (<any>rotation).playerGroupStr = pg.name + ' ,';
      }

      if ((<any>rotation).playerGroupStr.length >= 2) {
        (<any>rotation).playerGroupStr = (<any>rotation).playerGroupStr.substring(0, (<any>rotation).playerGroupStr.length - 2);
      }

      // make rotationitem nodes
      for (const lp of rotation.screenLayout.layoutPanels) {

        let riIndex = -1;
        for (const ri of lp.rotationItems) {

          riIndex += 1;
          // add screen
          if (ri.screen) {
            // extend rotationitem class
            (<any>ri).categoryRotationName = rotation.name;
            (<any>ri).sizeString = this.formatBytes(ri.screen.ScreenSizeInBytes);
            (<any>ri).skipReasons = this.getSkipReasons(ri, null, rotation, compareDate);
            (<any>ri).index = riIndex;
          }
          // add category
          if (ri.screenCategory) {

            let criIndex = -1;
            // add ri's of category
            for (const cri of ri.screenCategory.childRotationItems) {
              criIndex += 1;
              // extend rotationitem class
              (<any>cri).categoryRotationName = rotation.name;
              (<any>cri).ownerScreenCategoryName = ri.screenCategory.name;
              (<any>cri).sizeString = this.formatBytes(cri.screen.ScreenSizeInBytes);
              (<any>cri).skipReasons = this.getSkipReasons(cri, ri, rotation, compareDate);
              (<any>cri).index = criIndex;
            }

          }

        }

      }

    }

  }

  getSkipReasons(ri: RotationItem, categoryRi: RotationItem, rotation, compareDate: Date): string[] {
    const sr: string[] = [];
    if (ri.screen) {
      if (!this.playerService.scheduleService.checkTimeframes(null, ri.scheduleTimeframes, null, compareDate)) {
        sr.push(`Screen is outside it's scheduled timeframe`);
      }
    }

    if (ri.triggerable && !ri.inScheduleWhenTriggerEnabled) {
      sr.push(`Triggering is enabled, but 'Include when not triggered is disabled'`);
    }

    if (!ri.enabled) {
      sr.push(`Screen is part of schedule, but is set to disabled`);
    }

    if (categoryRi) {
      if (!this.playerService.scheduleService.checkTimeframes(null, categoryRi.scheduleTimeframes, null, compareDate)) {
        sr.push(`Screen is in a category that is outside it's scheduled timeframe`);
      }

      if (!categoryRi.enabled) {
        sr.push(`Screen is part of schedule, but its's category${categoryRi.screenCategory ? ' (' + categoryRi.screenCategory.name + ')' : ''} is set to disabled`);
      }
    }

    if (rotation) {
      if (!this.playerService.scheduleService.checkTimeframes(null, rotation.scheduleTimeframes, null, compareDate)) {
        sr.push(`Screen is in a Rotation that is outside it's scheduled timeframe`);
      }
    }

    return sr;
  }

  createPlayOrderView(compareDate: Date) {

  }


  pad(num) {
    return ('0' + num).slice(-2);
  }
  hhmmss(secs) {
    let minutes = Math.floor(secs / 60);
    secs = secs % 60;
    const hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    return this.pad(hours) + ':' + this.pad(minutes) + ':' + this.pad(secs);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-view/schedule-view.component.ts